module.exports = __webpack_public_path__ + "img/landingReview.db2f47ca.png";